import {Component} from '@angular/core';

@Component({
  selector: 'app-advanced-tooltip',
  templateUrl: './advanced-tooltip.component.html',
  styleUrls: ['./advanced-tooltip.component.sass']
})
export class AdvancedTooltipComponent {
  isOpen = false;
  protected readonly encodeURI = encodeURI;

  protected handlePointerUp($event: PointerEvent) {
    if ($event.pointerType == 'touch') {
      $event.stopImmediatePropagation();
      this.isOpen = !this.isOpen;
    }
  }
}

@Component({
  selector: 'tooltip-body',
  template: `
    <ng-content>tooltip-body</ng-content>`,
  styles: `:host
             display: flex`,
})
export class TooltipBody {
}

@Component({
  selector: 'tooltip-popout',
  template: `
    <mat-card class="status-history-popover">
      <mat-card-content>
        <ng-content>tooltip-popout</ng-content>
      </mat-card-content>
    </mat-card>`,
})
export class TooltipPopout {
}
